<template>    
    <v-card light flat hover color="transparent" v-if="canupload">
        <v-card-title class="justify-center">
            {{ attributes.hint }}
            <!--<code>{{uploading}}</code> -->
        </v-card-title>
        
        <v-card-text >  
            <div id="my-strictly-unique-vue-upload-multiple-image" style="display: flex; justify-content: center;">
                <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @edit-image="editImage"
                    @data-change="dataChange"
                    @mark-is-primary=""
                    :data-images="images"
                    
                ></vue-upload-multiple-image>
            </div>

        </v-card-text>
        <formstopperdialog
            :show="uploading">
            
        </formstopperdialog>
    </v-card>
       
</template>

<script>
    import VueUploadMultipleImage from './VueUploadMultipleImage.vue'
    import FormMultiImageUpload from './FormMultiImageUpload.vue'
    import formstopperdialog from './FormStopperDialog.vue'
    import messagesmixin from '../../mixins/MessagesMixin.js';
    export default {
        mixins: [
            messagesmixin
        ],
        props:[
            'attributes',
            'itemsnamespace',
            'parent_id',
            'item',
            'paths',
            'value'
        ],
        data () {
            return {                
                uploading:false,
                //images:[],
                
            }
        },
        computed:{            
            
            canupload (){return typeof this.parent_id != 'undefined'},            
            itemdata(){return typeof this.item == 'undefined' ? null : this.$store.getters[this.itemsnamespace+ "/getsingle"](this.item)},
            itemsrc:{            
                get (){return !this.itemdata?'': this.paths.storagepath + this.itemdata.serverpath},
                set(value){this.itemdata.serverpath=value}
            },
            images:{
                get() {
                    return this.$store.getters[this.attributes.items].filter(x => x.entity_id==this.parent_id)
                }
            }
        },
        components: {
            VueUploadMultipleImage,
            formstopperdialog
        },
        methods: {
            async uploadImageSuccess(formData, index, fileList) {
                //console.log('data', formData, index, fileList)
                
                formData.append('default',fileList[index].default)
                await this.uploadImage(formData)
               
            },
            beforeRemove (index, done, fileList) {
                console.log('index', index, fileList)
                var r = confirm("remove image")
                if (r == true) {
                    this.deleteImage(fileList[index].id)
                    done()
                } else {
                }
            },
            async editImage (formData, index, fileList) {
                //alert('edit: ' + JSON.stringify(fileList[index]))
                //console.log('edit data', formData, index, fileList)
                
                formData.append('default',fileList[index].default)
                await this.uploadImage(formData,fileList[index].id)
                
            },
            dataChange (data) {
                //alert('change')
                let formData = new FormData()
                console.log(data)
            },
            defaultChange (index, fileList) {
                //alert('change')
                let formData = new FormData()
                formData.append('default',fileList[index].default)
                this.uploadImage(formData, fileList[index].id)
            },
            uploadImage(formData,id=undefined) {
                this.uploading=true
                if(this.canupload){
                    //alert('hier')
                    
                    formData.append('entity_id',this.parent_id)                      
                    if(typeof id != 'undefined') {
                        formData.append('_method', 'PUT')
                    }
                    
                    this.$store.dispatch(this.itemsnamespace+'/postForm',{'payload':formData, 'id':id})
                        .then(response=>{
                            if(typeof id == 'undefined') {
                                this.$emit('input',response.data.id)
                            }    
                            this.setMessage('200','Erfolg. Das Bild wurde hochgeladen/geändert')
                            this.$store.commit('logos/LOGO_SET_LOGO', {result:response.data,entity_id:this.parent_id})    
                        })
                        .catch(error=>{
                            this.setMessage(error.response.status,error.response.data.errors)
                        })
                    
                }                
                this.uploading=false
            },
            async deleteImage(id){
                this.uploading=true
                this.$store.dispatch(this.itemsnamespace +'/deleteById',id)
                        .then(response=>{
                            this.setMessage('200','Erfolg. Das Bild wurde gelöscht')
                        }).catch(error => {
                            this.setMessage(error.response.status,error.response.data.errors)
                        })
                await this.$store.dispatch(this.vuexnamespace + '/getById',this.parent_id)
                this.uploading=false
            }
            
        }
    }
</script>
    